import styled from 'styled-components'

export const StyledTable = styled.div`
   height: 100%;
   overflow-x: hidden;
   overflow-y: auto;
   position: relative;
   width: 100%;
   -webkit-overflow-scrolling: touch;
   scrollbar-gutter: stable;

   &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
   }
   &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
   }
   .dark &::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.2);
   }

   & .table-scroll-x {
      overflow-x: auto;
      overflow-y: visible;
      width: 100%;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
         display: none;
      }
   }

   & table {
      background-color: #ffffff;
      border-collapse: separate;
      border-radius: 12px;
      border-spacing: 0;
      border: 1px solid #e5e7eb;
      width: 100%;
      min-width: 560px;
      table-layout: auto;

      .dark & {
         background-color: #2e2d2d;
         border: 1px solid #5e5e5e;
      }

      & thead {
         position: sticky;
         top: 0;
         z-index: 2;
         & tr:first-child th:first-child {
            border-top-left-radius: 12px;
         }
         & tr:first-child th:last-child {
            border-top-right-radius: 12px;
         }
      }
      & tbody {
         & tr:last-child td:first-child {
            border-bottom-left-radius: 12px;
         }
         & tr:last-child td:last-child {
            border-bottom-right-radius: 12px;
         }
      }

      & tr:not(:last-child) {
         & td {
            border-bottom: 1px solid #e5e7eb;
         }
         .dark & td {
            border-bottom: 1px solid #5e5e5e;
         }
      }
      & tr {
         width: 100%;
         & td:not(:last-child),
         & th:not(:last-child) {
            border-right: 1px solid #e5e7eb;
            .dark & {
               border-right: 1px solid #5e5e5e;
            }
         }
         & th {
            background-color: #f1f5f9;
            border-bottom: 1px solid #e5e7eb;
            color: #292b32;
            font-size: clamp(13px, 1.6vw, 16px);
            font-weight: 500;
            padding: 0;
            text-align: left;
            white-space: nowrap;
            &[data-padding='true'] {
               padding: clamp(8px, 1.2vw, 12px) clamp(10px, 1.6vw, 16px);
            }
         }
         .dark & th {
            border-bottom: 1px solid #5e5e5e;
         }
         & td {
            background-color: #ffffff;
            color: #292b32;
            font-size: clamp(12.5px, 1.5vw, 15px);
            font-weight: 400;
            padding: 0;
            text-align: left;
            &[data-padding='true'] {
               padding: clamp(8px, 1.2vw, 12px) clamp(10px, 1.6vw, 16px);
            }
         }
         & td[data-fill='true'] {
            padding: 0 !important;
         }
         & td .cell-content {
            display: inline-block;
            max-width: min(320px, 40vw);
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: middle;
            white-space: nowrap;
         }
         & td .cell-fill {
            align-items: stretch;
            display: flex;
            height: 100%;
            width: 100%;
         }
         & td .cell-fill > * {
            align-items: center;
            border-radius: 0 !important;
            box-sizing: border-box;
            display: flex;
            height: 100%;
            margin: 0 !important;
            padding: 12px 16px;
            width: 100%;
         }
         &:nth-child(even) {
            & td {
               background-color: #f1f5f9;
               color: #292b32;
            }
         }
         .dark &:nth-child(even) {
            & td {
               background-color: #353535bf;
               color: #e1e1e1;
            }
         }
         .dark & th {
            background-color: #353535bf;
            color: #e1e1e1;
         }
         .dark & td {
            background-color: #2e2d2d;
            color: #e1e1e1;
         }
      }

      /* ===== chap tomonda fixed (sticky) ustunlar ===== */
      & [data-sticky='true'] {
         position: sticky;
         z-index: 1;
         background-clip: padding-box;
      }
      & thead [data-sticky='true'] {
         z-index: 3;
      }
      & [data-sticky-last='true'] {
         box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
      }
      .dark & [data-sticky-last='true'] {
         box-shadow: 2px 0 4px rgba(0, 0, 0, 0.35);
      }

      /* sticky kataklar doim TO'LIQ (opaque) fonga ega bo'lishi shart,
         aks holda scroll paytida orqadagi ustunlar matni "shaffoflik"
         orqali ko'rinib qoladi (ayniqsa dark-mode'dagi bf-alpha ranglarda) */
      & tr td[data-sticky='true'] {
         background-color: #ffffff;
      }
      & tr th[data-sticky='true'] {
         background-color: #f1f5f9;
      }
      & tr:nth-child(even) td[data-sticky='true'] {
         background-color: #f1f5f9;
      }
      .dark & tr td[data-sticky='true'] {
         background-color: #2e2d2d;
      }
      .dark & tr th[data-sticky='true'] {
         background-color: #353535;
      }
      .dark & tr:nth-child(even) td[data-sticky='true'] {
         background-color: #3a3838;
      }
   }

   & .sticky-hscrollbar {
      position: sticky;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 12px;
      overflow-x: auto;
      overflow-y: hidden;
      z-index: 4;
      background: rgba(255, 255, 255, 0.9);
      border-top: 1px solid #e5e7eb;
      backdrop-filter: blur(2px);

      .dark & {
         background: rgba(46, 45, 45, 0.9);
         border-top: 1px solid #5e5e5e;
      }
      &::-webkit-scrollbar {
         height: 8px;
      }
      &::-webkit-scrollbar-thumb {
         background-color: rgba(0, 0, 0, 0.3);
         border-radius: 10px;
      }
      .dark &::-webkit-scrollbar-thumb {
         background-color: rgba(255, 255, 255, 0.3);
      }
      & .sticky-hscrollbar-inner {
         height: 1px;
      }
   }

   @media (max-width: 640px) {
      & table {
         min-width: 480px;
         & tr th[data-padding='true'],
         & tr td[data-padding='true'] {
            padding: 8px 10px;
         }
      }
      & tr td .cell-content {
         max-width: 55vw;
      }
      & table [data-sticky='true'] {
         position: static;
         box-shadow: none;
      }
      & .sticky-hscrollbar {
         display: none;
      }
   }
`